import theme from '@adsk/alloy-react-theme';

export const trialMessagesWrapper = {
  display: 'flex',
};

export const dividerStyle = {
  backgroundColor: theme.colors.adskBlue500,
  height: '20px',
  margin: '8px 6px 0 0',
  width: '3px',
};

export const trialMessageTitleStyle = {
  ...theme.typography.bodyMediumBold,
  margin: '8px 3px 0 0',
};

export const trialMessageTextStyle = {
  ...theme.typography.bodyMedium,
  margin: '8px 0 0 0',
};
